/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsSbomVulnerabilityResponse {
    getFixupPrototypeFunction() { return AppSecopsSbomVulnerabilityResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsSbomVulnerabilityResponse>): AppSecopsSbomVulnerabilityResponse {
        let obj = Object.assign(new AppSecopsSbomVulnerabilityResponse(), model);
        AppSecopsSbomVulnerabilityResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsSbomVulnerabilityResponse>): AppSecopsSbomVulnerabilityResponse {
        if (!model) return null;
        return AppSecopsSbomVulnerabilityResponse.newInstance(<AppSecopsSbomVulnerabilityResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsSbomVulnerabilityResponse) {
        if (!obj) return;

        models.AppSecopsSbomVulnerabilityResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsSbomVulnerabilityResponse): boolean {
        Object.setPrototypeOf(obj, AppSecopsSbomVulnerabilityResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.next_list_context) {
            models.ListContext.fixupPrototype(this.next_list_context);
        }
        if (this.results) {
            for (let val of this.results) {
                models.AppSecopsSbomVulnerability.fixupPrototype(val);
            }
        }
    }

    /**
     * List of result identifiers
     */
    results: Array<models.AppSecopsSbomVulnerability>;

    /**
     * List context
     */
    next_list_context: models.ListContext;

}
